import React from 'react'

const SearchMobile = () => (
	<form id="mobile-search-form" method="get" className="mobile-only" action="/">
		<label htmlFor="mobile-search"><i className="fa fa-search" aria-hidden="true"></i><span>Search</span></label>
		<input type="hidden" name="post_type" value="product" />
		<input id="mobile-search" type="text" className="" name="s" placeholder="Search Sample Packs & Software" autoComplete="off" />
		<input id="mobile-search-submit" className="" type="submit" value="Search" />
	</form>
)
export default SearchMobile